var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "timer_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#timer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3a.97.97 0 0 1-.713-.288A.97.97 0 0 1 9 2q0-.424.287-.712A.97.97 0 0 1 10 1h4q.424 0 .713.288Q15 1.575 15 2q0 .424-.287.712A.97.97 0 0 1 14 3zm2 11q.424 0 .713-.287A.97.97 0 0 0 13 13V9a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 8a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 9v4q0 .424.287.713.288.287.713.287m0 8a8.65 8.65 0 0 1-3.488-.712A9.2 9.2 0 0 1 5.65 19.35a9.2 9.2 0 0 1-1.938-2.863A8.65 8.65 0 0 1 3 13q0-1.85.712-3.488A9.2 9.2 0 0 1 5.65 6.65a9.2 9.2 0 0 1 2.862-1.937A8.65 8.65 0 0 1 12 4a8.9 8.9 0 0 1 2.975.5Q16.4 5 17.65 5.95l.7-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-.7.7a9.7 9.7 0 0 1 1.45 2.675Q21 11.45 21 13a8.65 8.65 0 0 1-.712 3.488 9.2 9.2 0 0 1-1.938 2.862 9.2 9.2 0 0 1-2.863 1.938A8.65 8.65 0 0 1 12 22m0-2q2.9 0 4.95-2.05T19 13t-2.05-4.95T12 6 7.05 8.05 5 13t2.05 4.95T12 20"
  }))));
};
export default SvgTimer;